import React from 'react';
import { motion } from 'framer-motion';
import { Download, Wrench, Smile } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download size={40} data-id="element-89" />,
    title: 'Descargás la guía',
    desc: 'Acceso inmediato a tu PDF después del pago.'
  }, {
    icon: <Wrench size={40} data-id="element-90" />,
    title: 'Hackeás tu living',
    desc: 'Aplicás 2 o 3 cambios simples con lo que tenés en casa.'
  }, {
    icon: <Smile size={40} data-id="element-91" />,
    title: 'Disfrutás la paz',
    desc: 'Mirás cómo tu gato ignora el sillón para treparse a su nuevo lugar favorito.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-cream" data-id="element-92">
      <div className="max-w-5xl mx-auto" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-4xl mb-4" data-id="element-95">¿Cómo funciona?</h2>
          <p className="text-xl text-warmBrown/70" data-id="element-96">
            Simple, rápido y al grano.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-97">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-amber/20 z-0" data-id="element-98"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-99">
              <div className="w-24 h-24 bg-white rounded-full shadow-md flex items-center justify-center text-amber mb-6 border-4 border-cream" data-id="element-100">
                {step.icon}
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-101">{step.title}</h3>
              <p className="text-lg text-warmBrown/80" data-id="element-102">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}